// extracted by mini-css-extract-plugin
export default {"rroWarningBox":"styles_rroWarningBox__3fwd4","rroWarningTitle":"styles_rroWarningTitle__zv2rJ","rroWarningText":"styles_rroWarningText__D4Jty"};